<div
  class="cv-page cv11"
  [ngClass]="{ 'thumbnail-view': isThumbnail }"
>
  <div class="cv-frame">
    <!-- HEADER -->
    <header class="cv-header">
      <!-- LEFT HEADER -->
      <div class="header-left">
        <div class="fullname">
          <h1 class="name">{{ data.firstName }}</h1>
          <h1 class="name">{{ data.lastName }}</h1>
        </div>
        <p
          class="designation"
          *ngIf="data.designation"
        >
          {{ data.designation }}
        </p>
      </div>

      <!-- RIGHT HEADER -->
      <div
        class="header-right"
        *ngIf="data.about"
      >
        <h3 class="section-title">SUMMARY</h3>
        <p>{{ data.about }}</p>
      </div>
    </header>

    <!-- BODY -->
    <div class="cv-body">
      <!-- LEFT COLUMN -->
      <aside class="left-col">
        <!-- CONTACT -->
        <section class="contact-info">
          <p *ngIf="data.contactDetails?.number">
            <strong>Phone:</strong> {{ data.contactDetails.number }}
          </p>
          <p *ngIf="data.contactDetails?.email">
            <strong>Email:</strong> {{ data.contactDetails.email }}
          </p>
          <p *ngIf="data.contactDetails?.address">
            <strong>Address:</strong>
            {{ data.contactDetails.address || data?.city }}
          </p>
          <p *ngIf="data.contactDetails?.linkedIn">
            <strong>LinkedIn:</strong> {{ data.contactDetails.linkedIn }}
          </p>
        </section>

        <!-- SKILLS -->
        <section
          class="skills"
          *ngIf="data.skills?.length"
        >
          <h3 class="section-title">SKILLS</h3>
          <ul>
            <li *ngFor="let skill of data.skills">{{ skill }}</li>
          </ul>
        </section>

        <!-- EDUCATION -->
        <section
          class="education"
          *ngIf="data.educations?.length"
        >
          <h3 class="section-title">EDUCATION</h3>
          <div
            *ngFor="let edu of data.educations"
            class="edu"
          >
            <p class="degree">{{ edu.courseName }}</p>
            <p class="uni">{{ edu.universityName }}</p>
            <p class="timeline">{{ edu.formattedDate }}</p>
            <p
              class="location"
              *ngIf="edu.location"
            >
              {{ edu.location }}
            </p>
          </div>
        </section>

        <!-- CERTIFICATIONS -->
        <section
          class="certifications"
          *ngIf="data.certifications?.length"
        >
          <h3 class="section-title">CERTIFICATIONS</h3>
          <ul>
            <li *ngFor="let cert of data.certifications">
              <strong *ngIf="cert.name">{{ cert.name }}</strong>
              <span *ngIf="cert.authority"> ({{ cert.authority }})</span>
            </li>
          </ul>
        </section>
      </aside>

      <!-- RIGHT COLUMN -->
      <main class="right-col">
        <section
          class="experience"
          *ngIf="data.experience?.length"
        >
          <h3 class="section-title">WORK EXPERIENCE</h3>
          <div
            class="exp-item"
            *ngFor="let exp of data.experience"
          >
            <h4 class="job-title">{{ exp.Title }}</h4>
            <p class="company-location">
              {{ exp.company }}
              <span *ngIf="exp.location"> | {{ exp.location }}</span>
            </p>
            <p class="dates">
              {{ exp.startDate }} - {{ exp.endDate || 'Present' }}
            </p>
            <ul class="description-points">
              <li *ngFor="let point of exp.descriptionPoints">{{ point }}</li>
            </ul>
          </div>
        </section>
      </main>
    </div>
  </div>
</div>
